module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-3-051f7a6336c032609efc0e47ead6e6dd.jpg";